<br />
<div class="container-fluid">
  <!-- <div class="row" *ngIf="authService.isAdmin$ | async">
    <div class="col-sm">
      <div class="float-right">
        <button
          type="button"
          class="btn btn-primary waves-light"
          data-toggle="modal"
          data-target="#exampleModalLong"
        >
          Add Product
        </button>
      </div>
    </div>
  </div> -->
  <div class="row">
    <div class="container" *ngIf="origins$| async as origins">
      <div class="form-group">
        <div class="row">
          <div class="col-sm-4 mb-2">
            <form [formGroup]="sortForm" class="form-group">
              <label for="sortOption">Ordina:</label>
              <select formControlName="sortOption" class="form-control">
                <option *ngFor="let option of sortingOptions " [ngValue]="option">{{
                  option.display
                  }}</option>
              </select>
            </form>
          </div>

          <div class="col-sm-4 mb-2">
            <form [formGroup]="originForm" class="form-group">
              <label for="origin">Paese di origine:</label>
              <select formControlName="origin" class="form-control">
                <option></option>
                <option *ngFor="let origin of origins" [ngValue]="origin">
                  {{ origin | titlecase }}
                </option>
              </select>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-12">
      <div class="container">
        <app-card-loader [loop]="3" [height]="800" *ngIf="loading"></app-card-loader>
        <div class="row" *ngIf="!loading">
          <!-- List of Products -->
          <div class="col-sm-4 mb-2" *ngFor="
              let product of productList
                | paginate:  { id: 'server', itemsPerPage: pageSize, currentPage: pageIndex, totalItems: total }
            ">
            <div class="item">
              <div class="mb-r">
                <!--Card-->
                <div class="card card-cascade wider">
                  <!--Card image-->
                  <a [routerLink]="['/products/product', product.product_id]">
                    <div class="text-center p-1">
                      <img
                        [src]="product.thumbnail_picture_url ? product.thumbnail_picture_url : './assets/img/placeholder-image.png'"
                        class="img-fluid" alt="" width="360px" height="640px" />
                      <a>
                        <div class="mask waves-effect waves-light" mdbRippleRadius></div>
                      </a>
                    </div>
                  </a>
                  <!--/.Card image-->
                  <!--Card content-->
                  <div class="card-body text-center no-padding">
                    <!--Category & Title-->
                    <a class="text-muted">
                      <h5>{{ product.productCategory }}</h5>
                    </a>
                    <p class="card-title">
                      <strong>
                        <a [routerLink]="['/products/product', product.product_id]"
                          routerLinkActive="router-link-active">{{ product.description | titlecase }}</a>
                      </strong>
                    </p>
                    <!--Description-->
                    <p>{{ product.product_details["origin"] | titlecase }}</p>
                    <!--Card footer-->
                    <div class="card-footer">
                      <span class="left">Offerta minima: € {{ product.price }}</span>
                      <span class="right">
                        <a placement="top" mdbTooltip="Aggiungi a Carrello" container="body" (click)="addToCart(product)">
                          <i class="fa fa-shopping-basket"></i>
                        </a>
                      </span>
                    </div>
                  </div>
                  <!--/.Card content-->
                </div>
                <!--/.Card-->
              </div>
            </div>
          </div>
        </div>
        <!-- Pagination -->
        <div class="text-center mt-3">
          <div class="spinner" [ngClass]="{ 'hidden': !loading }"></div>
          <pagination-controls (pageChange)="getPage($event)" id="server"></pagination-controls>
        </div>
      </div>
      <!--/.Card-->
    </div>
  </div>
</div>